import { useParams } from 'react-router';

export const useCompanyIdFromUrl = () => {
  const { companyID } = useParams();

  return companyID;
};
